// src/pages/AboutPage.js
import React from 'react';
import { useEffect } from 'react';
import { Brain, Search, TrendingUp, Calculator, Users, BarChart3, MessageSquare, Zap } from 'lucide-react';

const AboutPage = () => {
    useEffect(() => {
  // גלילה חלקה לראש העמוד
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            אודות מערכת גמלנט AI
          </h1>
          <p className="text-xl md:text-2xl font-light max-w-3xl mx-auto leading-relaxed">
            בינה מלאכותית. בחירה חכמה. שליטה מלאה.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        {/* מבוא */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              גמלנט AI היא מערכת חדשנית להשוואת מוצרי חיסכון והשקעה לטווח ארוך –
              כולל קרנות השתלמות, קופות גמל, קופות גמל להשקעה, קרנות פנסיה, ביטוחי מנהלים ופוליסות חיסכון –
              המבוססת על ניתוחים מתקדמים של נתוני אמת ממקורות רגולטוריים רשמיים כמו גמל נט, פנסיה נט וביטוח נט.
            </p>
            
            <div className="bg-blue-50 border-r-4 border-blue-500 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-blue-800 mb-3">המטרה שלנו ברורה:</h3>
              <p className="text-blue-700 text-lg">
                לאפשר לכל חוסך בישראל – לא רק ליועצים או למקצוענים – להבין איפה בדיוק מושקע הכסף שלו,
                ומהם המסלולים שמספקים באמת את התמונה הכי חדה, הכי עקבית, והכי רלוונטית להיום.
              </p>
            </div>
          </div>
        </div>

        {/* איך זה עובד */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center flex items-center justify-center gap-3">
              <Search className="w-8 h-8 text-blue-600" />
              איך זה עובד בפועל?
            </h2>

            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div>
                <h3 className="text-xl font-bold text-gray-700 mb-4 flex items-center gap-2">
                  <BarChart3 className="w-5 h-5 text-blue-600" />
                  🔎 המערכת סורקת ומנתחת
                </h3>
                <p className="text-gray-600 mb-4">
                  באופן שוטף את שלושת מאגרי המידע של משרד האוצר במוצרי ההשקעה:
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                    קופות גמל
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                    קרנות השתלמות
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                    קרנות פנסיה
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                    ביטוחי מנהלים
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                    קופות גמל להשקעה
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                    פוליסות חיסכון פיננסיות
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-700 mb-4 flex items-center gap-2">
                  <Brain className="w-5 h-5 text-blue-600" />
                  🧠 ניתוח בינה מלאכותית
                </h3>
                <p className="text-gray-600 mb-4">
                  המערכת מפשטת עבור המשתמש את הנתונים ומציגה אותם בצורה מיידית, ברורה וממוקדת, עם ממשק משתמש נוח, מנוע חיפוש חכם עם יכולת להבין מענה על שאלות בשפה חופשית.
                </p>
                <p className="text-sm text-gray-500 mb-2">תשואות, מדדי סיכון, הרכב השקעות, עקביות, דמי ניהול:</p>
                <ul className="space-y-1 text-sm text-gray-600">
                  <li>• ללא השערות</li>
                  <li>• ללא הכללות</li>
                  <li>• ללא מניפולציות</li>
                  <li>• באובייקטיביות מושלמת</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* סוכן AI */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-gradient-to-br from-indigo-600 to-purple-700 text-white rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold mb-6 text-center flex items-center justify-center gap-3">
              <MessageSquare className="w-8 h-8" />
              רכיב הפענוח של גמלנט AI
            </h2>
            
            <p className="text-lg mb-6 text-center">
              משלב בינה מלאכותית אשר מאפשר למשתמש לשאול שאלות חופשיות בשפה טבעית –
              והמערכת תחזיר תשובה מיידית, מדויקת ועניינית, מתוך ניתוח של הדאטה הסגור בלבד.
            </p>

            <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm">
              <h3 className="font-bold mb-4">לדוגמה, תוכל לשאול:</h3>
              <div className="space-y-3">
                <div className="bg-white/20 rounded-lg p-4 border-r-4 border-yellow-300">
                  <p className="italic">"מצא לי את כל המסלולים שברובם חשופים לשוק הישראלי"</p>
                </div>
                <div className="bg-white/20 rounded-lg p-4 border-r-4 border-green-300">
                  <p className="italic">"הצג לי מסלולים בחו״ל עם גידור מט״ח"</p>
                </div>
                <div className="bg-white/20 rounded-lg p-4 border-r-4 border-pink-300">
                  <p className="italic">"איזו קרן השתלמות במסלול כללי שומרת על העקביות הגבוהה ביותר בשנים האחרונות?"</p>
                </div>
              </div>
              <div className="mt-6 p-4 bg-gray-800/30 rounded-lg border border-white/20">
                <p className="font-bold text-center mb-2">
                  המערכת לא מייעצת – היא משקפת.
                </p>
                <p className="text-center">
                  לא מדמיינת – היא מפענחת.
                </p>
                <p className="text-sm text-center mt-2 text-gray-200">
                  כל התשובות נשענות על נתוני אמת מתוך גמלנט, פנסיה נט וביטוח נט – במעגל סגור, שקוף ומפוקח.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ניתוח ושיקוף הנתונים */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center flex items-center justify-center gap-3">
              <Brain className="w-8 h-8 text-blue-600" />
              ניתוח ושיקוף הנתונים בבינה מלאכותית
            </h2>

            <p className="text-lg text-gray-700 mb-6 text-center">
              מערכת גמלנט AI לא רק מציגה נתונים בצורה מרשימה, מיידית ופשוטה למשתמש –
              היא מעניקה דירוג חכם ותדיר לכל מסלול השקעה.
            </p>

            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-lg mb-6">
              <h3 className="text-xl font-bold text-blue-800 mb-3">Credit Score חכם</h3>
              <p className="text-blue-700 mb-4">
                המבוסס על ניתוח רב־שכבתי המחבר בין ביצועים, סיכון ועקביות.
              </p>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-bold text-gray-800 mb-2">הציון מתמקד בעיקר ב:</h4>
                  <ul className="space-y-1 text-gray-700 text-sm">
                    <li>• תשואות בפועל, מצטברות וממוצעות</li>
                    <li>• לחמש תקופות מדויקות: 1, 2, 3, 4, 5 שנים</li>
                    <li>• משקל גבוה יותר לטווחים הקצרים (1-3)</li>
                    <li>• משקף מגמות עדכניות ורלוונטיות</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="font-bold text-gray-800 mb-2">מדדים תומכים:</h4>
                  <ul className="space-y-1 text-gray-700 text-sm">
                    <li>• <strong>מדד שארפ</strong> – איכות התשואה ביחס לסיכון</li>
                    <li>• <strong>עקביות יחסית</strong> – מיקום לאורך זמן</li>
                    <li>• <strong>ביצועים יציבים</strong> – בכל תקופות ההשוואה</li>
                    <li>• <strong>מדדי תנודתיות</strong> – רמת הסיכון בפועל</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* תכונות נוספות */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              מה עוד תמצאו בגמלנט AI?
            </h2>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4 p-4 bg-blue-50 rounded-lg">
                <Calculator className="w-8 h-8 text-blue-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-gray-800 mb-2">מחשבוני מיסוי מתקדמים</h3>
                  <p className="text-gray-600 text-sm">כדי שתבין את ההשלכות האמיתיות של כל מוצר – עוד לפני קבלת ההחלטה</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-green-50 rounded-lg">
                <Users className="w-8 h-8 text-green-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-gray-800 mb-2">השוואה ברת־קיימא</h3>
                  <p className="text-gray-600 text-sm">התאמה חכמה לפרופיל הסיכון שלך, משווה בין כלל יצרני התשואות תחת רגולציית משרד האוצר</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-purple-50 rounded-lg">
                <TrendingUp className="w-8 h-8 text-purple-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-gray-800 mb-2">גרפים פשוטים לצד עומק מקצועי</h3>
                  <p className="text-gray-600 text-sm">כי מידע חכם לא חייב להיראות מסובך – הוא רק צריך להיות מדויק</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-orange-50 rounded-lg">
                <Zap className="w-8 h-8 text-orange-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-gray-800 mb-2">מנוע דירוג מתקדם ופורץ דרך</h3>
                  <p className="text-gray-600 text-sm">תובנות שלא תמצאו באף אתר אחר – מבוסס ביצועים עקביים לכל תקופות ההשקעה של חמש השנים האחרונות</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* סיכום */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white rounded-2xl shadow-lg p-8 text-center">
            <h2 className="text-3xl font-bold mb-6">העתיד כבר כאן – רק צריך לדעת לשאול נכון</h2>
            
            <div className="space-y-4 text-lg mb-8">
              <p>אנחנו לא באנו להחליף יועצים.</p>
              <p>באנו לעשות סדר.</p>
              <p>לתת כוח.</p>
              <p>ולפתוח את הדלת לעולם שבו כל חוסך מקבל כלים חכמים – בלחיצת כפתור.</p>
            </div>

            <blockquote className="border-t border-gray-600 pt-6 mt-8 text-xl italic font-light">
              "ההבדל בין מי שמתכנן את העתיד – לבין מי שמניח שהוא כבר מסודר – מתחיל בשאלה אחת: 
              האם אתה שואל את המערכת הנכונה?"
            </blockquote>

            <div className="mt-8 text-2xl font-bold text-blue-300">
              גמלנט AI – כי העתיד לא שואל אותך אם אתה מוכן.
              <br />
              הוא פשוט מוגש לך בלחיצת כפתור.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;